import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import informationTechnology from "../../../assets/infoandtech.png";
import forecast from "../../../assets/forecast.png";
import accounting from "../../../assets/accounting.png";
import procureToPay from "../../../assets/procurePay.png";
import orderToCash from "../../../assets/orderToCash.png";
import machine from "../../../assets/packing-machine.png";

const EDA = () => {
  const navigate = useNavigate();

  const handleCardClick = (card) => {
    navigate("/Insights/eda-dashboard-list", {
      state: {
        selectedProcess: card.selectedProcess,
        category: "EDA",
      },
    });
  };

  const cardData = [
    {
      title: "Procure To Pay",
      image: procureToPay,
      selectedProcess: "procureToPay",
    },
    {
      title: "Forecast to Deploy",
      image: forecast,
      selectedProcess: "forecastToDeploy",
    },
    {
      title: "Information Technology",
      image: informationTechnology,
      selectedProcess: "informationTechnology",
    },
    {
      title: "Order to Cash",
      image: orderToCash,
      selectedProcess: "orderToCash",
    },
    {
      title: "General Acc. & Reporting",
      image: accounting,
      selectedProcess: "generalAccRep",
    },
    {
      title: "Property Plant & Equipment",
      image: machine,
      selectedProcess: "propertyPlantEquipment",
    },
  ];

  return (
    <div className="eda-container">
      {cardData.map((card, index) => (
        <div
          key={index}
          className="eda-card"
          onClick={() => handleCardClick(card)}
        >
          <div className="eda-card-title">{card.title}</div>

          <div className="eda-card-image">
            <img src={card.image} alt={card.title} />
          </div>

          <div className="eda-card-footer">Click To View</div>
        </div>
      ))}
    </div>
  );
};

export default EDA;
